import Swiper from 'swiper';
import { Navigation, EffectFade, Thumbs } from 'swiper/modules';

export default () => {
    const nodeSelectors = {
        slider: '[js-slider="slider"]',
        nextBtn: '[js-slider="slider-next-btn"]',
        prevBtn: '[js-slider="slider-prev-btn"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        const insightsSlider = new Swiper(nodeSelectors.slider, {
            modules: [Navigation, EffectFade, Thumbs],
            slidesPerView: 1,
            speed: 800,
            navigation: {
                nextEl: nodeSelectors.nextBtn,
                prevEl: nodeSelectors.prevBtn,
            },
            breakpoints: {
                750: {
                    slidesPerView: 2
                },
                1100: {
                    slidesPerView: 3
                }
            }
            
        });
    }

    return Object.freeze({
        init,
    })
}